import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PeopleToolbarService {
  private readonly createClickSubject = new Subject<void>();

  readonly createClicks$: Observable<void> =
    this.createClickSubject.asObservable();

  requestCreate(): void {
    this.createClickSubject.next();
  }
}
